import Enum from "../../../../../../enums/Enum";

const SeverityEnum = new Enum({
    MILD: {name: "Mild"},
    MODERATE: {name: "Moderate"},
    SEVERE: {name: "Severe"}
});

export default SeverityEnum;